$(function() {
    var editionId = $('#edition_id').val();

    $('#edition_filter').on('change', function() {
        var optionSelected = $('#edition_filter').find(":selected");

        if (!optionSelected) {
            return;
        }

        var filterType = getFilterType(optionSelected.data('filter-type'));

        if (!filterType) {
            location.href = '?';
            return;
        }

        location.href = `?filter_by=${filterType}&filter=${$(this).val()}`;
    });

    $('#edition_filter').select2({
        allowClear: true,
        theme: 'bootstrap-5',
        placeholder: 'Filtrar por cadernos e seções'
    });

    $('#section_list_search').on('change', function() {
        location.href = '?section_name=' + $(this).val();
    });

    $('#subsection_list_search').on('change', function() {
        location.href = '?subsection_name=' + $(this).val();
    });

    // Click handler for act cards - uses per-act loading with complete endpoint
    $('.act-card').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var actId = $(this).attr('data-act-id');
        var actPage = parseInt($(this).attr('data-act-page') || '1', 10) || 1;
        var isEmergency = $('#emergency_edition').length;

        $('.act-card').removeClass('selected');
        $(this).addClass('selected');

        loadPerAct(actId, editionId, actPage, isEmergency).then(function(){
            loadActAttachments(actId);
        });
    });

    $('.act-next-page').on('click', function() {
        var actId = $(this).attr('data-act-id');
        var actPage = $(this).attr('data-act-page');
        changeActPageView(editionId, actId, actPage);
    });

    $('.act-prev-page').on('click', function() {
        var actId = $(this).attr('data-act-id');
        var actPage = $(this).attr('data-act-page');
        changeActPageView(editionId, actId, actPage);
    });

    $('#page-button').on('click', function () {
        var actId = $(this).data('act-id');
        var actPage = $('#page-input').val();
        changeActPageView(editionId, actId, actPage);
    });

    $('#download-button').on('click', function () {
        var editionId = $(this).data('edition-id');
        var editionTitle = $(this).data('edition-name');
        axios.get(
            '/edicao/' + editionId + '/complete/link',
        ).then(function (data) {
            if (
                typeof data.error_code !== 'undefined' ||
                data.status != 200
            ) {
                return false;
            }

            const link = document.createElement("a");
            link.href = data.data.url;
            link.download = editionTitle + '.pdf';
            link.click();
        });
    });

    init();


    function normalizeText(text) {
        if (!text) return '';
        return text.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    function countOccurrences(text, searchTerm) {
        if (!text || !searchTerm) {
            return 0;
        }
        var normalizedText = normalizeText(text);
        var normalizedTerm = normalizeText(searchTerm);
        var regex = new RegExp(normalizedTerm, 'gi');
        var matches = normalizedText.match(regex);
        if (matches) {
            return matches.length;
        }
        return 0;
    }

    async function performEditionSearch() {
        var searchTerm = $('#edition-search-input').val().trim();

        if (searchTerm === '') {
            $('.act-card').show();
            $('.edition-book, .edition-section, .edition-subsection').show();
            $('.act-result-count').hide();
            $('#no-results-message').hide();
            return;
        }

        $('#no-results-message').html('<div class="text-body">Buscando...</div>').show();

        try {
            var response = await axios.get('/edicao/' + editionId + '/search', {
                params: {
                    q: searchTerm
                }
            });

            if (!response || !response.data || !response.data.results) {
                $('#no-results-message').html('<div class="text-body font-weight-semibold">Erro ao buscar. Tente novamente.</div>').show();
                return;
            }

            var searchResults = response.data.results;
            var foundResults = false;
            var normalizedSearchTerm = normalizeText(searchTerm);

            $('.act-card').each(function() {
                var $card = $(this);
                var actId = $card.data('act-id');
                var actTitle = $card.data('act-title') || '';
                var $countElement = $card.find('.act-result-count');

                var normalizedTitle = normalizeText(actTitle);
                var foundInTitle = normalizedTitle.indexOf(normalizedSearchTerm) !== -1;
                var titleCount = foundInTitle ? countOccurrences(actTitle, searchTerm) : 0;

                var contentCount = 0;
                var foundInContent = false;

                if (searchResults[actId]) {
                    foundInContent = true;
                    contentCount = searchResults[actId].count || 0;
                }

                var totalCount = titleCount + contentCount;

                if (foundInTitle || foundInContent) {
                    if (totalCount > 0) {
                        var countText = totalCount === 1 ? '(1 resultado)' : '(' + totalCount + ' resultados)';
                        $countElement.text(countText).show();
                    }

                    $card.show();
                    foundResults = true;
                } else {
                    $card.hide();
                }
            });

            $('.edition-book, .edition-section, .edition-subsection').each(function() {
                var $category = $(this);
                var $nextElements = $category.nextUntil('.edition-book, .edition-section, .edition-subsection');
                var hasVisibleActs = $nextElements.filter('.act-card:visible').length > 0;

                if (hasVisibleActs) {
                    $category.show();
                } else {
                    $category.hide();
                }
            });

            if (!foundResults) {
                $('#no-results-message').html('<div class="text-body font-weight-semibold">Nenhum resultado encontrado para \'<span id="search-term">' + searchTerm + '</span>\' nesta edição.</div>').show();
            } else {
                $('#no-results-message').hide();
            }
        } catch (error) {
            console.error('Erro ao buscar:', error);
            $('#no-results-message').html('<div class="text-body font-weight-semibold">Erro ao buscar. Tente novamente.</div>').show();
        }
    }

    $('#edition-search-input').on('keypress', function(e) {
        if (e.which === 13) {
            e.preventDefault();
            performEditionSearch();
        }
    });

    $('#edition-search-btn').on('click', function() {
        performEditionSearch();
    });

    $('#edition-clear-btn').on('click', function() {
        $('#edition-search-input').val('');
        $('#edition-clear-btn').hide();
        performEditionSearch();
    });

    $('#edition-search-input').on('input', function() {
        var value = $(this).val().trim();

        if (value !== '') {
            $('#edition-clear-btn').show();
        } else {
            $('#edition-clear-btn').hide();
            performEditionSearch();
        }
    });
});

function init() {
    if (
        screen.width < 768 ||
        window.innerWidth < 768
    ) {
        return;
    }

    var urlParams = new URLSearchParams(window.location.search);
    var actSelected = urlParams.get('act');
    var actCard = null;
    var actNotFound = false;

    if (actSelected) {
        actCard = $('#act-card-' + actSelected);
        actNotFound = !actCard.length;
    } else {
        actCard = $('.act-card').first();
    }

    if (actNotFound) {
        actCard = $('.act-card').first();
        if (actCard.length) {
            if (typeof toastr !== 'undefined' && toastr && typeof toastr.warning === 'function') {
                toastr.warning('Ato não encontrado para esta edição. Abrindo o primeiro ato disponível.');
            }
        }
    }

    if (actCard.length) {
        var actId = actCard.data('act-id');
        var editionId = $('#edition_id').val();
        var isEmergency = $('#emergency_edition').length;

        $('.act-card').removeClass('selected');
        actCard.addClass('selected');

        if (actCard[0] && typeof actCard[0].scrollIntoView === 'function') {
            actCard[0].scrollIntoView({ block: 'nearest' });
        }

        loadPerAct(actId, editionId, 1, isEmergency).then(function(){
            loadActAttachments(actId);
        });
    }
}

function changeActPageView(
    editionId,
    actId,
    page = 1,
    emergency = 0,
    keepSelection = false
) {
    var actPage = page;
    var isFiltered = $('#filtered').val();

    if (
        isFiltered == 1 &&
        $('.act-card.selected').length == 1
    ) {
        var selectedActId = $('.act-card.selected').attr('id');
        actPage = $('#' + selectedActId).attr('data-act-page');
        $('#filtered').val(0);
        isFiltered = 0;
    }

    let url = '/edicao/' + editionId + '/ato/' + actPage;

    if (emergency) {
        url = '/ato/' + actId + '/emergency';
    }

    axios.get(url).then(function (data) {
        if (
            typeof data.error_code !== 'undefined' ||
            data.status != 200
        ) {
            return false;
        }

        var content = $('.act-view-content');
        content.empty();
        var useViewer = (typeof window !== 'undefined' && window.READER_USE_PDFJS && window.PDFJS_VIEWER);
        var iframeSrc = data.data.url;
        if (useViewer) {
            var proxied = '/pdf/proxy?url=' + encodeURIComponent(data.data.url);
            iframeSrc = window.PDFJS_VIEWER + '?file=' + encodeURIComponent(proxied);
        }
        content.append('<iframe class="w-100" style="width:100%;height:80vh;border:0;" src="' + iframeSrc + '" title="PDF Viewer"></iframe>');

        var total = data.data.total;
        var currentPage = actPage;
        var prev = data.data.prev_page;
        var next = data.data.next_page;

        if (next > total) {
            next = total;
        }

        if (prev < 1) {
            prev = 1;
        }

        if (!keepSelection) {
            var closestLower = null;
            var selectedActPage = $('.act-card.selected').attr('data-act-page');
            $(".act-card").each(function() {
                let pg = parseInt($(this).attr("data-act-page"));

                if (pg == actPage) {
                    closestLower = null
                    selectedActPage = actPage;
                    return;
                }

                if (
                    pg < actPage &&
                    (
                        closestLower === null ||
                        pg > closestLower
                    )
                ) {
                    closestLower = $(this).attr('data-act-page');
                }
            });

            if (
                closestLower != null &&
                currentPage != closestLower
            ) {
                selectedActPage = closestLower;
            }

            if ($('.act-card[data-act-page=' + selectedActPage + ']').length != 0) {
                $('.act-card').removeClass('selected');
            }

            $('.act-card[data-act-page=' + selectedActPage + ']').addClass('selected');
        }

        $('.act-prev-page').data('act-id', actId);
        $('.act-next-page').data('act-id', actId);
        $('.act-prev-page').attr('data-act-page', prev);
        $('.act-next-page').attr('data-act-page', next);
        $('#page-button').data('act-id', actId);
        $('.act-current-page').empty();
        $('.act-current-page').append(currentPage + ' de ' + total);
        $('.act-view').show();
        $('.act-view').removeClass('hidden');
    });
}

function loadActAttachments(actId) {
    var content = $('.act-attachments');
    var card = $('.act-attachments-card');
    card.hide();
    content.empty();
    axios.get(
        '/ato/' + actId + '/attachments',
    ).then(function (data) {
        if (
            typeof data.error_code !== 'undefined' ||
            data.status != 200
        ) {
            return false;
        }

        data.data.forEach(function(attachment) {
            content.append(`
                <a
                    href="/attachment/${attachment['id']}"
                    class="mr-md-2"
                >
                    <i class="bi bi-file-earmark-text"></i>
                    ${attachment['filename']}
                </a>
            `);
        });

        if (data.data.length > 0) {
            card.show();
        }
    });
}

function getFilterType(type) {
    if (!type) {
        return null;
    }

    switch (type) {
        case 1:
            return 'book';
        case 2:
            return 'section';
        case 3:
            return 'subsection';
        default:
            return null;
    }
}

// Helper functions for per-act PDF loading
function useViewer() {
    return (typeof window !== 'undefined' && window.READER_USE_PDFJS && window.PDFJS_VIEWER);
}

function renderIframe(url, actId) {
    var content = $('.act-view-content');
    content.empty();
    var iframeSrc = url;
    if (useViewer()) {
        var proxied = '/pdf/proxy?url=' + encodeURIComponent(url);
        iframeSrc = window.PDFJS_VIEWER + '?file=' + encodeURIComponent(proxied);
    }
    content.append('<iframe class="w-100" style="width:100%;height:80vh;border:0;" src="' + iframeSrc + '" title="PDF Viewer"></iframe>');
    $('.act-prev-page').data('act-id', actId);
    $('.act-next-page').data('act-id', actId);
    $('.act-prev-page').attr('data-act-page', 1);
    $('.act-next-page').attr('data-act-page', 1);
    $('#page-button').data('act-id', actId);
    $('.act-current-page').empty().append('1 de 1');
    $('.act-view').show().removeClass('hidden');
    $('.legacy-pagination').addClass('d-none');
}

function loadPerAct(actId, editionId, actPage, isEmergency) {
    if (isEmergency) {
        return axios.get('/ato/' + actId + '/emergency').then(function(resp){
            var url = resp && resp.status === 200 && resp.data ? (resp.data.url || '') : '';
            if (url) { renderIframe(url, actId); }
            return url;
        });
    }
    return axios.get('/ato/' + actId + '/complete').then(function(resp){
        var data = (resp && resp.status === 200 && resp.data) ? resp.data : {};
        var url = data.url || '';
        var mode = (data.render_mode || '').toLowerCase();
        var startPage = data.start_page || null;

        // Explicit legacy per-page mode signaled by backend
        if (mode === 'per_page') {
            var page = parseInt(actPage, 10);
            if (!page || isNaN(page)) { page = startPage || 1; }

            // Render immediately if backend already provided a per-page URL
            if (url) { renderIframe(url, actId); }

            // Fetch pagination metadata (and URL fallback) for the chosen page
            return axios.get('/ato/' + actId + '/page/' + page).then(function(r){
                var meta = r && r.status === 200 && r.data ? r.data : {};
                var legacyUrl = meta.url || '';
                if (!url && legacyUrl) { renderIframe(legacyUrl, actId); }

                var total = meta.total ? meta.total : 1;
                var prev = meta.prev_page ? meta.prev_page : (page > 1 ? page - 1 : 1);
                var next = meta.next_page ? meta.next_page : (page + 1);
                $('.act-prev-page').data('act-id', actId).attr('data-act-page', prev);
                $('.act-next-page').data('act-id', actId).attr('data-act-page', next);
                $('#page-button').data('act-id', actId);
                $('.act-current-page').empty().append(page + ' de ' + total);
                $('#page-input').val(page);
                $('.legacy-pagination').removeClass('d-none');
                return legacyUrl || url;
            });
        }

        // Per-act (or edition) mode
        if (url) {
            renderIframe(url, actId);
            $('.legacy-pagination').addClass('d-none');
            return url;
        }

        // Safety fallback to legacy endpoint if URL absent
        var fallbackPage = actPage || 1;
        return axios.get('/ato/' + actId + '/page/' + fallbackPage).then(function(r){
            var legacyUrl = r && r.status === 200 && r.data ? (r.data.url || '') : '';
            if (legacyUrl) {
                renderIframe(legacyUrl, actId);
                var total = (r && r.data && r.data.total) ? r.data.total : 1;
                var currentPage = fallbackPage;
                var prev = (r && r.data && r.data.prev_page) ? r.data.prev_page : (currentPage > 1 ? currentPage - 1 : 1);
                var next = (r && r.data && r.data.next_page) ? r.data.next_page : (currentPage + 1);
                $('.act-prev-page').data('act-id', actId).attr('data-act-page', prev);
                $('.act-next-page').data('act-id', actId).attr('data-act-page', next);
                $('#page-button').data('act-id', actId);
                $('.act-current-page').empty().append(currentPage + ' de ' + total);
                $('#page-input').val(currentPage);
                $('.legacy-pagination').removeClass('d-none');
            }
            return legacyUrl;
        });
    });
}

// Override changeActPageView to use per-act loading
(function(){
    var originalChange = window.changeActPageView;
    window.changeActPageView = function(editionId, actId, page, emergency, keepSelection){
        loadPerAct(actId, editionId, page, emergency).then(function(url){
            if (!url && typeof originalChange === 'function') {
                originalChange(editionId, actId, page, emergency, keepSelection);
            }
        }).catch(function(){
            if (typeof originalChange === 'function') {
                originalChange(editionId, actId, page, emergency, keepSelection);
            }
        });
    };
})();
